import type { SurveySummaryOption, SurveySummaryQuestion } from "../../types/survey.types";

export function getResponseOptions(question: SurveySummaryQuestion): SurveySummaryOption[] {
  const statistics = question.statistics;

  if (statistics?.kind === "text") return statistics.answers;
  if (statistics?.kind === "choice" || statistics?.kind === "boolean") {
    return statistics.options;
  }
  if (statistics?.kind === "numeric" || statistics?.kind === "temporal") {
    return statistics.options;
  }

  return question.options ?? [];
}
